import { createContext } from 'react';

interface EvaluationModalContextValue {
  onOpen: (evaluationId: number) => void;
}

export const EvaluationModalContext =
  createContext<EvaluationModalContextValue | null>(null);
